import { jsx as m } from "react/jsx-runtime";
import { useToast as c } from "@chakra-ui/react";
import { Alert as p } from "../alert/alert.js";
import { ThemeShadowVariable as h } from "../../theme/theme-types.js";
function w() {
  const a = c();
  return { showToast: ({
    type: o = "info",
    duration: s = 3e3,
    description: r,
    title: e,
    distanceToBottom: n
  }) => {
    const t = { base: "100%", md: "560px" };
    a({
      duration: s,
      position: "bottom",
      status: o === "neutral" ? "info" : o,
      isClosable: !0,
      render: ({ onClose: i }) => /* @__PURE__ */ m(p, { title: e, type: o, onClose: i, boxShadow: h.Small, children: r }),
      containerStyle: {
        maxW: "100%",
        px: "8px",
        minW: t,
        w: t,
        pb: n ?? {
          base: "8px",
          md: "48px"
        }
      }
    });
  } };
}
export {
  w as useToast
};
